import { withTheme } from "styled-components";
export const ThemeSwap = withTheme(({
  theme,
  light = null,
  dark = null
}) => {
  return !!theme.dark ? dark : light;
});